import { defineSlotRecipe } from '@chakra-ui/react';

export const alertRecipe = defineSlotRecipe({
  slots: ['root'],
  className: 'chakra-alert',
  base: {
    root: {
      paddingInlineStart: '0.75rem !important',
      paddingInlineEnd: '0.75rem !important',
      paddingBlockStart: '0.5rem !important',
      paddingBlockEnd: '0.5rem !important',
      borderWidth: '1px',
      borderColor: 'var(--fgWarning)',
    },
  },
});
